/* TypeScript file generated from Icon.res by genType. */

/* eslint-disable */
/* tslint:disable */

import * as IconJS from './Icon.res.js';

export type t = 
    "none"
  | "blank-placeholder"
  | "legacy_toggle_list_arrows"
  | "legacy_printer"
  | "legacy_printer_locked"
  | "legacy_burger"
  | "legacy_search"
  | "legacy_back"
  | "legacy_alert_tip"
  | "legacy_info_tip"
  | "legacy_settings"
  | "legacy_ticket"
  | "legacy_switch"
  | "legacy_arrow_up_overlay"
  | "legacy_arrow_up"
  | "legacy_arrow_down"
  | "legacy_arrow_left"
  | "legacy_arrow_right"
  | "legacy_queue_arrow_left"
  | "legacy_queue_arrow_right"
  | "legacy_queue_arrow_up"
  | "legacy_queue_arrow_down"
  | "legacy_double_arrow_left"
  | "legacy_double_arrow_right"
  | "legacy_export"
  | "legacy_import"
  | "legacy_edit"
  | "legacy_help"
  | "legacy_notification"
  | "legacy_plus"
  | "legacy_bordered_plus"
  | "legacy_analytics"
  | "legacy_close"
  | "legacy_oval"
  | "legacy_sales"
  | "legacy_products"
  | "legacy_contacts"
  | "legacy_filter"
  | "legacy_delete"
  | "legacy_more_x"
  | "legacy_more_y"
  | "legacy_inner_oval"
  | "legacy_calendar"
  | "legacy_clipboard"
  | "legacy_tick"
  | "legacy_download"
  | "legacy_export_download"
  | "legacy_external_link"
  | "legacy_cloud_save"
  | "legacy_customer_support"
  | "legacy_reset"
  | "legacy_danger"
  | "legacy_warning"
  | "legacy_printing_label"
  | "tick"
  | "arrow_left"
  | "arrow_right"
  | "arrow_up"
  | "arrow_down"
  | "more_v1"
  | "more_v2"
  | "status_info"
  | "status_add"
  | "status_ok"
  | "status_nok"
  | "status_warning"
  | "see_ok"
  | "edit"
  | "duplicate_v1"
  | "duplicate_v2"
  | "delete"
  | "archive"
  | "unarchive"
  | "plus_large"
  | "plus_small"
  | "variant_add"
  | "variant_see"
  | "chevron_up"
  | "chevron_down"
  | "chevron_right"
  | "chevron_left"
  | "wine_product"
  | "beer_product"
  | "spirit_product"
  | "simple_product"
  | "pdf_see"
  | "excel_see"
  | "csv_see"
  | "sync_circular"
  | "import"
  | "export"
  | "external_link"
  | "filter_v1"
  | "filter_v2"
  | "cross"
  | "reset_v1"
  | "reset_v2"
  | "refresh_v1"
  | "printer"
  | "printer_locked"
  | "label_v1"
  | "label_v2"
  | "download_v1"
  | "download_v2"
  | "upload_v2"
  | "search"
  | "maximize_v1"
  | "maximize_v2"
  | "pending"
  | "hourglass"
  | "help_center"
  | "doc"
  | "copy"
  | "product_ok"
  | "product_nok"
  | "exit"
  | "send"
  | "store"
  | "contact_v3"
  | "contact_ok"
  | "link_v2"
  | "cake"
  | "currency"
  | "percent"
  | "gift"
  | "loyalty";

export type props<name,fill,width,height,unit,bold,pressed> = {
  readonly name: name; 
  readonly fill: fill; 
  readonly width: width; 
  readonly height: height; 
  readonly unit?: unit; 
  readonly bold?: bold; 
  readonly pressed?: pressed
};

export const make: React.ComponentType<{
  readonly name: t; 
  readonly fill: string; 
  readonly width: number; 
  readonly height: number; 
  readonly unit?: string; 
  readonly bold?: boolean; 
  readonly pressed?: boolean
}> = IconJS.make as any;
